import styled from 'styled-components'

export const PlacementTitle = styled.div`
  color: #343e59;
  font-size: 16px;
  font-weight: 600;
  padding: 20px;
  border-bottom: 1px solid #e6e7ea;
`
export const PlacementInnerContainer = styled.div`
  padding: 20px;
`

export const PlacementContainer = styled.div`
  border: 1px solid #bbbbbb;
  border-radius: 13px;
  height: 80vh;
  scrollbar-width: thin;
  overflow: auto;
  max-height: 100%;
`

export const PlacementBoxContainer = styled.div`
  box-shadow: 0px 4px 4px 0px #00000040;
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 25px;
`

export const PlacedTitle = styled.div`
  color: ${props => (props.color ? props.color : '#4b465c')};
  font-size: 14px;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 700)};
  margin-bottom: 10px;
`

export const ColorDivider = styled.div`
  border-left: ${props =>
    props.color ? `4px solid ${props?.color}` : '#0FB680'};
  padding-left: 8px;
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
`

export const TextSection = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${props => (props.disabled ? '#B2B2B2' : '#3249d7')};
`
export const TableTextSection = styled.div`
  color: #000000;
  font-size: 10px;
  font-weight: 400;
  text-transform: capitalize;
`

export const StatusText = styled.div`
  color: ${props => (props.disabled ? '#B2B2B2' : props.color || '#0FB680')};
  font-size: 12px;
  font-weight: 400;
`

export const SortLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
`

export const IconStatusSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CompanyText = styled.div`
  color: ${props => (props.disabled ? '#B2B2B2' : ' #343e59')};
  font-size: 12px;
  font-weight: 400;
  text-transform: capitalize;
  white-space: ${props => (props.whiteSpace ? 'normal' : 'nowrap')};
`
